<template>
  <card id="endDeviceOverrideRxParameters" :title="$t('ed-overrideRxParameters:overrideRxParameters')" no-body no-footer>
    <table slot="card-table" class="table table-sm table-ellipsis mb-0">
      <tbody>
        <tr>
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:rx1Delay') }}</td>
          <td>{{ endDevice.rx1Delay !== null ? endDevice.rx1Delay : '-' }} s</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:rx2Dr') }}</td>
          <td>{{ endDevice.rx2Dr !== null ? endDevice.rx2Dr : '-' }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:rx2Freq') }}</td>
          <td>{{ endDevice.rx2Freq !== null ? endDevice.rx2Freq : '-' }} MHz</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:rxWindows') }}</td>
          <td>{{ rxWindows || '-' | capitalize }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:rx1DrOffset') }}</td>
          <td>{{ endDevice.rx1DrOffset !== null ? endDevice.rx1DrOffset : '-' }}</td>
        </tr>
        <tr v-if="canDisplayDwellTime">
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:dwellTime') }}</td>
          <td>{{ endDevice.dwellTime ? $t('ed-overrideRxParameters:dwellTimeEnabled') : $t('ed-overrideRxParameters:dwellTimeDisabled') | capitalize }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:cfList') }}</td>
          <td><p v-for="c in cfList" :key="c" class="mb-0">{{ c | capitalize }}</p></td>
        </tr>
        <tr v-if="endDevice.classType === 'B'">
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:pingSlotDr') }}</td>
          <td>{{ endDevice.pingSlotDr !== null ? endDevice.pingSlotDr : '-' }}</td>
        </tr>
        <tr v-if="endDevice.classType === 'B'">
          <td class="text-uppercase">{{ $t('ed-overrideRxParameters:pingSlotFreq') }}</td>
          <td>{{ endDevice.pingSlotFreq !== null ? endDevice.pingSlotFreq : '-' }} MHz</td>
        </tr>
      </tbody>
    </table>
  </card>
</template>

<script>
import { cfList as cfListConf } from '@/configuration/regions'

export default {
  props: {
    endDevice: {
      type: Object,
      required: true
    }
  },

  computed: {
    rxWindows () {
      return this.endDevice.rxWindows ? this.$t('ed-overrideRxParameters:rxWindows' + this.endDevice.rxWindows) : ''
    },

    // AS923, AU915 1.0.2C and AU915 1.0.3A
    canDisplayDwellTime () {
      if (this.endDevice.rfRegion === 'AS923') return true
      if (this.endDevice.rfRegion === 'AU915' && this.endDevice.macVersion === '1.0.2' && this.endDevice.regParamsRevision === 'C') return true
      if (this.endDevice.rfRegion === 'AU915' && this.endDevice.macVersion === '1.0.3') return true
      return false
    },

    cfList () {
      if (!this.endDevice.rfRegion) return '-'
      if (!this.endDevice.cfList) return '-'

      return this.endDevice.cfList.map((c, i) => this.$t('endDevices:cfList.' + cfListConf[this.endDevice.rfRegion].label + Number(i + 1)) + ': ' + c + (cfListConf[this.endDevice.rfRegion].type === 'freq' ? ' MHz' : ''))
    }
  }
}
</script>
